import React from 'react';
import AmountCell from 'pages/Dashboard/pages/Billing/Payments/AmountCell';
import {
  VirtualTableColumnDef as ColumnDef,
} from 'core/components/VirtualTable/types';
import {
  formatDate,
} from 'utils/date';
import {
  EncounterWithPayment,
} from 'views/EMR/Billing/AdjustPayment';
import {
  MoveToCreditLogViewModel,
} from 'dtos';
import ToolTip from 'core/components/Tooltip';
import Name from 'pages/Dashboard/components/Name';
import {
  useUserProfilePicturePath,
} from 'pages/Dashboard/hooks/media';

const encounterColumn: ColumnDef<MoveToCreditLogViewModel> = {
  id: 'encounter',
  accessorKey: 'encounterId',
  columnTitle: 'Encounter',
  size: 150,
  cell: ({ row }) => (
    <div className="gap-px flex flex-col font-semibold max-w-max">
      <span className="text-gray-500">
        {formatDate(row.original?.startDateTime ?? '')}
      </span>
      <small className="truncate inline-block max-w-fit">
        {row.original?.typeOfVisitDescription ?? '--'}
      </small>
    </div>
  ),
};

const amountMovedColumn: ColumnDef<MoveToCreditLogViewModel> = {
  id: 'amountMoved',
  accessorKey: 'moveToCreditAmount',
  columnTitle: 'Moved to Credit',
  size: 120,
  cell: ({ row, column }) => (
    <AmountCell<EncounterWithPayment>
      value={row.original?.moveToCreditAmount ?? 0}
      columnDef={column.columnDef}
      showZero
      showNegative={false}
    />
  ),
};

const movedAtColumn: ColumnDef<MoveToCreditLogViewModel> = {
  id: 'createdAt',
  accessorKey: 'createdAt',
  columnTitle: 'Transfer Date',
  size: 120,
  cell: ({ row }) => (
    <div className="gap-px flex flex-col font-semibold max-w-max">
      <span className="text-gray-500">
        {formatDate(row.original?.moveToCreditDate ?? '')}
      </span>
    </div>
  ),
};

type TransferredByCellProps = {
  row: MoveToCreditLogViewModel;
};

function TransferredByCell({ row: { movedByUserName, movedByUserId } }: TransferredByCellProps) {
  const src = useUserProfilePicturePath(movedByUserId ?? undefined);

  return movedByUserName === '--' ? (
    <p className="text-gray-500 font-semibold">
      --
    </p>
  ) : (
    <ToolTip
      title={movedByUserName ?? ''}
      placement="top"
      hide={movedByUserName === '--'}
    >
      <span className="truncate">
        <Name
          name={movedByUserName ?? ''}
          image={{ src }}
        />
      </span>
    </ToolTip>
  );
}

const movedByColumn: ColumnDef<MoveToCreditLogViewModel> = {
  id: 'movedBy',
  accessorKey: 'movedByUser',
  columnTitle: 'Transferred By',
  size: 200,
  cell: ({ row }) => <TransferredByCell row={row.original} />,
};

const moveToCreditLogsColumns: ColumnDef<EncounterWithPayment>[] = [
  movedAtColumn,
  encounterColumn,
  amountMovedColumn,
  movedByColumn,
];

export default moveToCreditLogsColumns;
